module.exports = __webpack_public_path__ + "static/media/background.d1d8ba08.png";